export default {
  // General UI elements
  save: "Salva",
  saving: "Salvataggio",
  cancel: "Annulla",
  edit: "modifica",
  delete: "Elimina",
  profile: "Profilo",
  settings: "Impostazioni",
  logout: "Esci",
  language: "Lingua",
  loading: "Caricamento",
  submit: "Invia",
  search: "Cerca...",
  back: "Indietro",
  next: "Avanti",
  previous: "Precedente",
  continue: "Continua",
  done: "Fatto",
  error: "Errore",
  success: "Successo",
  warning: "Avviso",
  info: "Informazione",
  close: "Chiudi",
  open: "Apri",
  yes: "Sì",
  no: "No",
  ok: "OK",
   
  // Authentication
  auth: {
    signIn: "Accedi",
    signUp: "Registrati",
    signOut: "Esci",
    forgotPassword: "Password dimenticata?",
    resetPassword: "Reimposta password",
    sendResetLink: "Invia link di reimpostazione",
    createAccount: "Crea account",
    alreadyHaveAccount: "Hai già un account?",
    dontHaveAccount: "Non hai un account?",
    or: "Oppure",
    continueWith: "Continua con",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    twitter: "Twitter",
    passwordRequirements: "La password deve contenere almeno 8 caratteri",
    passwordMatch: "Le password devono corrispondere",
    emailInvalid: "Inserisci un indirizzo email valido"
  },
  
  // Profile specific
  username: "Nome utente",
  email: "Email",
  password: "Password",
  confirmPassword: "Conferma password",
  joinDate: "Data di iscrizione",
  streak: "Serie",
  xp: "XP",
  plan: "Piano",
  free: "Gratuito",
  pro: "Pro",
  premium: "Premium",
  referralCode: "Codice referral",
  share: "Condividi",
  copy: "Copia",
  copied: "Copiato!",
  contactUs: "Contattaci",
  termsOfService: "Termini di servizio",
  privacyPolicy: "Informativa sulla privacy",
  accountSettings: "Impostazioni account",
  changePassword: "Cambia password",
  deleteAccount: "Elimina account",
  deleteAccountConfirm: "Sei sicuro di voler eliminare il tuo account? Questa azione non può essere annullata.",
  updateProfile: "Aggiorna profilo",
  profileUpdated: "Profilo aggiornato con successo",
  memberSince: "Membro dal",
  noSetsYet: "Ancora Nessun Set :(",
  upgradeToPro: "Passa a Pro",
  recentActivity: "Attività Recente",
  shareWithAFriend: "Condividi con un Amico",
  contactTheTeam: "Contatta il Team",
  termsAndConditions: "Termini e Condizioni",
  editUsername: "Modifica Nome Utente:",
  logOut: "Esci",
  usernameError1: "Il nome utente non può essere vuoto",
  usernameError2: "Inserisci un nome utente diverso o nuovo",
  usernameError3: "Il nome utente non può contenere spazi",
  usernameError4: "Il nome utente non può contenere lettere maiuscole",
  usernameError5: "Il nome utente non può contenere caratteri speciali",
  usernameError6: "Il nome utente deve essere compreso tra 4 e 18 caratteri",
  usernameError7: "Il nome utente contiene contenuti inappropriati",
  usernameError8: "Questo nome utente è già in uso",
  clickOrDragAndDrop: "Clicca o trascina e rilascia per caricare",
  confirm: "Conferma",
  retake: "Riprendi",

  // BottomNav
  profile: "Profilo",
  home: "Home",
  library: "La Mia Libreria",
  saved: "Salvato",
  rankings: "Classifiche",

  // Feature
  backToLibrary: "Torna alla Libreria",
  exploreSets: "Esplora Set",
  communitySets: "Set Della Comunità",
  mySets: "Miei Set",
  alreadyAdded: "Già Aggiunto",
  addToLibrary: "Aggiungi alla Libreria",
  loading: "Caricamento...",
  loadMoreSets: "Carica Altri Set",
  by: "Di",
  makePublic: "Rendi Pubblico",
  subscriptionRequired: "Abbonamento Richiesto",
  subscriptionRequiredMessage: "Puoi avere solo 10 set contemporaneamente nella libreria. Passa a premium per set illimitati!",

  // My Library
  deleteSet: "Elimina Set",
  deleteSetConfirmation: "Sei sicuro di voler eliminare questo set?",
  yesDelete: "Sì, Elimina",
  collections: "Set Pubblici",
  myLibrary: "La Mia Libreria",
  outOf10Sets: "di 10 set aggiunti.",
  switchBackToPro: "Torna a Pro",
  upgradeToPro: "Passa a Pro",
  outOf10OnFree: "di 10 gratuiti.",
  letMeCook: "Lascia che cucini",
  selectMode: "Seleziona Modalità",
  multipleChoice: "Scelta Multipla",
  flashcards: "Flashcards",
  freeResponse: "Risposta Libera",
  proOnly: "Solo per Pro",
  leaderboard: "Classifica",
  favorites: "Preferiti",
  profile: "Profilo",
  reportBugs: "Segnala Bug",

  // Question Card
  correctMessage: "Corretto! Ben Fatto.",
  typeYourAnswer: "Scrivi la tua risposta...",
  submitAnswer: "Invia Risposta",
  responseCannotBeBlank: "La risposta non può essere vuota",
  noAnswerAvailable: "Nessuna risposta disponibile",
  answerGuideline: "Linee Guida per la Risposta:",
  pleaseSubmitAnswerFirst: "Per favore, invia la tua risposta prima",
  revealAnswer: "Rivela Risposta",
  hideAnswer: "Nascondi Risposta",
  gradingInProgress: "Valutazione in corso...",
  grading: "Valutazione",
  answerGuidelines: "Linee Guida per la Risposta",
  finalScore: "Punteggio Finale:",
  evaluateAnswer: "Valuta Risposta",

  // Saved
  favorites: "Preferiti",
  searchQuestions: "Cerca domande...",
  noSavedQuestions: "Ancora Nessuna Domanda Salvata.",

  // Scroller
  loadingMoreQuestions: "Caricamento di Altre Domande",

  // New Prompt
  deleteSet: "Elimina Set",
  deleteSetConfirmation: "Sei sicuro di voler eliminare questo set?",
  yesDelete: "Sì, Elimina",
  cancel: "Annulla",
  setLimitReached: "Limite di Set Raggiunto",
  setLimitError: "Puoi avere solo 10 set contemporaneamente nella libreria. Passa a Premium per set illimitati!",
  close: "Chiudi",
  uploadNotes: "Carica Note",
  general: "Generale",
  title: "Titolo",
  setTitleMessage: "Imposta un titolo per le tue domande generate da AI di Cookr, in modo che sia facile da accedere in seguito.",
  titleError1: "Il titolo non può essere vuoto",
  titleError2: "Il titolo contiene contenuti inappropriati",
  content: "Contenuto",
  setContentMessage: "Copia e incolla le tue note, le lezioni o qualsiasi altro contenuto testuale.",
  contentError1: "Il contenuto non può essere vuoto",
  contentError2: "Il contenuto contiene contenuti inappropriati",
  subject: "Soggetto",
  setSubjectMessage: "Di quale soggetto o argomento si tratta questo contenuto?",
  subjectError1: "Il soggetto non può essere vuoto",
  subjectError2: "Il soggetto contiene contenuti inappropriati",

  // Payment Confirmation
  returnToProfile: "Torna al Profilo",

  // Plans
  confirmSwitch: "Conferma Passaggio al Piano Gratuito",
  confirmSwitchMessage: "Sei sicuro di voler passare al Piano Gratuito? Perderai l'accesso alle funzionalità premium.",
  buttonConfirm: "Conferma Passaggio",
  processing: "In Elaborazione...",
  unlimitedScrolling: "Scorrimento Illimitato",
  unlimitedSubjects: "Soggetti Illimitati",
  aiTutorBot: "Bot Tutor AI",
  newFeatureAccess: "Accesso alle Nuove Funzionalità",
  saveScrolls: "Salva Scrolls",
  infiniteNoteUploads: "Caricamenti di Note Illimitati",
  answerExplanations: "Spiegazioni delle Risposte",
  shareScrolls: "Condividi Scrolls",
  everythingInStandard: "Tutto nel Piano Standard",
  current: "Corrente",
  switchOver: "Passa a",
  forever: "/per sempre",
  monthly: "/al mese",
  yearly: "/all'anno",

  // Leaderboard
  leaderboard: "Classifica",

  // Home.js
  pickASubject: "Scegli un argomento per iniziare la tua sessione!",

  // scrollerLoader
  generatingContent: "Generazione del Contenuto...",

  // Dropdown
  choose: "Scegli",
  titleTooLong: "Il titolo non può contenere più di 100 caratteri",
}

